import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "c-sitecart" }
const _hoisted_2 = {
  key: 0,
  class: "label"
}
const _hoisted_3 = { class: "label__dot" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Din kurv", -1)
const _hoisted_5 = {
  key: 0,
  class: "lineitems"
}
const _hoisted_6 = {
  key: 1,
  class: "empty"
}
const _hoisted_7 = { class: "summery" }
const _hoisted_8 = { class: "line line__shipping" }
const _hoisted_9 = {
  key: 0,
  class: "line--price"
}
const _hoisted_10 = { class: "line line--total" }
const _hoisted_11 = { class: "line--price" }
const _hoisted_12 = { class: "actions" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "actions__cart" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "context__head" }
const _hoisted_17 = { class: "context__content" }

import { computed, ref, watch } from "vue";
import SlideInObject from "@/vue/components/objects/SlideInObject.vue";

import CartIcon from "@web/assets/icon/cart.svg";
import CartLineItem from "@/vue/components/commerce/objects/CartLineItem.vue";
import ShippingProgress from "@/vue/components/commerce/objects/ShippingProgress.vue";
import InlineProduct from "@/vue/components/product/InlineProduct.vue"; //TODO: Create Favorite product
import { getComplementaryFromCart } from "@/vue/api/product/getComplementary.ts";
import { logClick } from "@/vue/api/clerk/log.ts";

import { useStore } from "vuex";
import { ProductObjectViewModel } from "../@types/generated/ProductObjectViewModel";

export default /*#__PURE__*/_defineComponent({
  __name: 'SiteCart',
  setup(__props) {

const store = useStore();

const cart = computed(() => store.state.commerce.commerceCart);
const siteUrl = computed(() => store.state.app.siteUrl);
const translations = computed(() => store.state.translations.siteTranslations);

const isOpen = ref(false);
const complementary = ref([1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]);
const contextLoading = ref(true);

function toggleSlideIn() {
	isOpen.value = !isOpen.value;
}

const fetchContext = computed(() => {
	if (complementary.value[0] !== 1) {
		return false;
	}

	if (!isOpen.value) {
		return false;
	}

	if (window.innerWidth < 900) {
		return false;
	}

	if (!cart.value?.productIds?.length) {
		return false;
	}

	return true;
});

const showContext = computed(() => {
	if (window.innerWidth < 900) {
		return false;
	}

	if (!cart.value?.productIds?.length) {
		return false;
	}

	return true;
});

watch(
	() => fetchContext.value,
	(newValue, oldValue) => {
		if (newValue) {
			fetch();
		}
	}
);

function track(slide: ProductObjectViewModel | number) {
	if (typeof slide == "number") {
		return;
	}

	logClick(slide.id);
}

async function fetch() {
	contextLoading.value = true;

	const response = await getComplementaryFromCart();

	if (response.data.success) {
		complementary.value = response.data.result;
	}

	contextLoading.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", {
      class: "c-sitecart__button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSlideIn()))
    }, [
      _createVNode(_unref(CartIcon)),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (cart.value.productQty)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(cart.value.productQty), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(SlideInObject, {
      "is-open": isOpen.value,
      "aria-label": "Site cart",
      onClose: _cache[1] || (_cache[1] = ($event: any) => (toggleSlideIn()))
    }, _createSlots({
      head: _withCtx(() => [
        _hoisted_4
      ]),
      header: _withCtx(() => [
        _createVNode(ShippingProgress)
      ]),
      body: _withCtx(() => [
        (cart.value.productQty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cart.value.lineItems, (lineItem) => {
                return (_openBlock(), _createBlock(CartLineItem, {
                  key: lineItem.id,
                  lineItem: lineItem
                }, null, 8, ["lineItem"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(translations.value["No products in cart"]), 1)
            ]))
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", null, _toDisplayString(translations.value["Shipping"]), 1),
            (cart.value.productQty > 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(cart.value.shippingTotal.priceAsCurrency), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", null, [
              _createElementVNode("strong", null, _toDisplayString(translations.value["Subtotal"]), 1),
              _createElementVNode("span", null, " (" + _toDisplayString(cart.value.productQty) + " " + _toDisplayString(translations.value["products"]) + ")", 1)
            ]),
            _createElementVNode("h2", _hoisted_11, _toDisplayString(cart.value.subtotal.priceAsCurrency), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("a", {
            class: _normalizeClass(["actions__checkout o-btn", { 'o-btn--disabled': !cart.value.productQty }]),
            href: siteUrl.value + 'shop/checkout'
          }, _toDisplayString(translations.value["Go to checkout"]), 11, _hoisted_13),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("a", {
              href: siteUrl.value + 'shop/cart'
            }, _toDisplayString(translations.value["See cart"]), 9, _hoisted_15)
          ])
        ])
      ]),
      _: 2
    }, [
      (showContext.value)
        ? {
            name: "context",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("p", null, _toDisplayString(translations.value["othersBought"]), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(complementary.value, (product) => {
                  return (_openBlock(), _createBlock(InlineProduct, {
                    key: product.id,
                    product: product,
                    loading: contextLoading.value,
                    onClick: ($event: any) => (track(product))
                  }, null, 8, ["product", "loading", "onClick"]))
                }), 128))
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["is-open"])
  ]))
}
}

})